import React, { Component } from "react";
import _ from "lodash";
import ReportTable from "./ReportTable";

const displayElements = [
  "offensedescription",
  "arrestDate",
  "arrestingagency",
  "counts",
  "caseType",
  "chargefilingDate",
  "disposition",
  "dispositionDate",
  "statute",
  "convictionDate",
  "offenseDate",
  "offensecode",
  "nciccode",
  "supervisioncounty",
  "supervisionDate",
  "commitmentlocation",
  "commitmentDate",
  "releaseDate",
  "bookingNumber",
  "court",
  "plea",
  "courtcosts",
  "fines",
  "restitution",
  "comments"
];
class OffenseDetail extends Component {
  componentDidMount() {}

  render() {
    const rowData = [];
    _.forEach(displayElements, elementName => {
      const element = _.get(this.props.record, `${elementName}[0]`);
      if (element !== undefined) {
        if (elementName.toLowerCase().includes("phone")) {
          const data = {
            key: element.$.display,
            value: element._,
            customType: "phone"
          };
          rowData.push(data);
        } else if (elementName.toLowerCase().includes("ssn")) {
          const data = {
            key: element.$.display,
            value: element._,
            customType: "ssn"
          };
          rowData.push(data);
        } else {
          const data = {
            key: element.$.display,
            value: element._
          };
          rowData.push(data);
        }
      }
    });
    if (this.props.countyorjurisdiction !== undefined) {
      const data = {
        key: "County/Jurisdiction",
        value: this.props.countyorjurisdiction._
      };
      rowData.push(data);
    }
    if (this.props.caseNumber !== undefined) {
      const data = {
        key: this.props.caseNumber.$.display,
        value: this.props.caseNumber._
      };
      rowData.push(data);
    }
    return <ReportTable rowData={rowData} {...this.props} />;
  }
}

export default OffenseDetail;



// WEBPACK FOOTER //
// ./src/components/reports/OffenseDetail.js